import moment from 'moment';

export const sortByDate = (a, b, key=null, currentDateFormat='DD-MM-YYYY HH:mm:ss') =>  {
    if(!key) {
        key = 'date';
    }
    const aDate = moment(a[key], currentDateFormat).format('YYYY-MM-DD HH:mm:ss');
    const bDate = moment(b[key], currentDateFormat).format('YYYY-MM-DD HH:mm:ss');
    return new Date(aDate) - new Date(bDate);
}

export const sortStringByKey = (a, b, key=null) => {
    return sortByString(a[key], b[key]);
}

export const sortByString = (a, b) => {
    if(a < b) { return -1; }
    if(a > b) { return 1; }
    return 0;
}

export const parseDateFormat = (dateString, currentDateFormat, expectedDateFormat) => {
    return moment(dateString, currentDateFormat).format(expectedDateFormat);
}